import React, { FC, useState } from "react";
import { Spin } from "antd";

const GoogleLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    <path fill="none" d="M0 0h48v48H0z"/>
  </svg>
);

const GoogleLoginBtn: FC = () => {
  const [loading, setLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const signInUser = (pathName: string) => {
    const baseUrl = process.env.REACT_APP_BASE_URL as string;
    const isLocalhost = baseUrl.includes('localhost') || baseUrl.includes('127.0.0.1');
    const protocol = isLocalhost ? 'http://' : 'https://';
    const cleanBaseUrl = baseUrl.replace(/^https?:\/\//, '');
    const redirectTo = `${protocol}${cleanBaseUrl}/${pathName}?path=finishSignup`;
    window.location.href = redirectTo;
  };

  const handleGoogleAuth = () => {
    const path = process.env.REACT_APP_GOOGLE_AUTH_ENDPOINT;
    setLoading(true);
    if (path) signInUser(path);
  };

  const getBackgroundColor = () => {
    if (isPressed) return '#e9e9e9';
    if (isHovered) return '#f2f2f2';
    return '#ffffff';
  };

  return (
    <button
      onClick={handleGoogleAuth}
      disabled={loading}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { setIsHovered(false); setIsPressed(false); }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={{
        width: '100%',
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        border: '1px solid #8c8c8c',
        borderRadius: '4px',
        background: getBackgroundColor(),
        transition: 'background 0.1s ease',
        cursor: loading ? 'wait' : 'pointer',
        fontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, sans-serif',
        fontSize: '15px',
        fontWeight: 500,
        color: '#3c4043',
        outline: 'none',
        padding: '0 12px',
      }}
    >
      {loading ? <Spin size="small" /> : <><GoogleLogo /><span>Sign in with Google</span></>}
    </button>
  );
};

export default GoogleLoginBtn;
